import 'rc-drawer/assets/index.css'
import React from 'react'
import DrawerMenu from 'rc-drawer'
import { withRouter } from 'react-router-dom'
import useApp from 'useApp'
import MenuLeft from './MenuLeft'
import MenuTop from './MenuTop'

@withRouter
class AppMenu extends React.Component {
  toggleOpen = () => {
    const { appSettings, setAppSettings } = this.props
    document
      .querySelector('#root')
      .setAttribute(
        'style',
        !appSettings.isMobileMenuOpen ? 'overflow: hidden; width: 100%; height: 100%;' : '',
      )
    setAppSettings({
      ...appSettings,
      isMobileMenuOpen: !appSettings.isMobileMenuOpen,
    })
  }

  render() {
    const {
      appSettings: { isMenuTop, isMobileMenuOpen, isMobileView, isLightTheme },
    } = this.props
    const BootstrappedMenu = () => {
      if (isMobileView) {
        return (
          <DrawerMenu
            getContainer={null}
            level={null}
            open={isMobileMenuOpen}
            onMaskClick={this.toggleOpen}
            onHandleClick={this.toggleOpen}
            className={isLightTheme ? 'drawer-light' : ''}
          >
            <MenuLeft />
          </DrawerMenu>
        )
      }
      if (isMenuTop) {
        return <MenuTop />
      }
      return <MenuLeft />
    }

    return BootstrappedMenu()
  }
}

const AppMenuWrapper = () => {
  const { ...rest } = useApp()
  return <AppMenu {...rest} />
}

export default AppMenuWrapper
